import React from 'react';

const styles = {
  container: {
    maxWidth: '700px',
    margin: '40px auto',
    padding: '25px',
    borderRadius: '12px',
    backgroundColor: '#f4fff4',
    border: '2px solid #008000',
    boxShadow: '0 6px 15px rgba(0, 128, 0, 0.2)',
    fontFamily: 'Segoe UI, sans-serif',
    color: '#003300',
    lineHeight: 1.6
  },
  header: {
    textAlign: 'center',
    fontSize: '30px',
    fontWeight: 'bold',
    color: '#008000',
    marginBottom: '20px'
  },
  subHeader: {
    fontSize: '22px',
    color: '#006400',
    margin: '15px 0 10px'
  },
  paragraph: {
    fontSize: '16px',
    marginBottom: '15px'
  },
  list: {
    paddingLeft: '20px',
    marginBottom: '15px'
  },
  listItem: {
    marginBottom: '8px'
  }
};

const AudiLuxuryCars = () => {
  return (
    <>
      <section
        className="page-title"
       style={{ backgroundImage: 'url(images/background/3.jpg)' }}
      >
        <div className="auto-container">
          <h1>Audi Luxury Car Rental</h1>
          <div className="bread-crumb-outer"></div>
        </div>
      </section>

      <div style={styles.container}>
        <h1 style={styles.header}>Audi S3, S5 & S6 Rentals by eTravo</h1>

        <p style={styles.paragraph}>
          Experience the perfect blend of luxury and power with <strong>eTravo’s Audi rental services</strong>. 
          Whether you're heading to a wedding, VIP airport pickup, or a celebrity shoot, our range of 
          Audi S-series sedans — S3, S5, and S6 — offers head-turning presence and unmatched performance.
        </p>

        <h2 style={styles.subHeader}>Audi Models Available:</h2>
        <ul style={styles.list}>
          <li style={styles.listItem}><strong>Audi S3:</strong> Compact sports sedan, ideal for city travel with performance flair.</li>
          <li style={styles.listItem}><strong>Audi S5:</strong> Sportback styling, premium comfort and elegant interior for high-end occasions.</li>
          <li style={styles.listItem}><strong>Audi S6:</strong> Executive sports luxury with twin-turbo V6 — built for prestige and performance.</li>
        </ul>

        <h2 style={styles.subHeader}>Key Features:</h2>
        <ul style={styles.list}>
          <li style={styles.listItem}>Quattro All-Wheel Drive</li>
          <li style={styles.listItem}>Virtual Cockpit with Audi MMI Touchscreen</li>
          <li style={styles.listItem}>Premium leather interiors & sunroof</li>
          <li style={styles.listItem}>Bang & Olufsen sound system (S5, S6)</li>
          <li style={styles.listItem}>Ambient lighting, cruise control, and full safety suite</li>
        </ul>

        <h2 style={styles.subHeader}>Best Use Cases:</h2>
        <ul style={styles.list}>
          <li style={styles.listItem}>Weddings & Luxury Events</li>
          <li style={styles.listItem}>VIP Guest Pickups</li>
          <li style={styles.listItem}>Music Videos & Film Shoots</li>
          <li style={styles.listItem}>Airport & Hotel Transfers</li>
          <li style={styles.listItem}>Corporate Executive Travel</li>
        </ul>

        <h2 style={styles.subHeader}>Why Choose eTravo?</h2>
        <p style={styles.paragraph}>
          At <strong>eTravo</strong>, we maintain a fleet of high-performance Audi models, fully insured,
          chauffeur-driven, and maintained to factory perfection. Our premium rental service ensures timely delivery,
          discreet chauffeurs, and flawless presentation — every time.
        </p>


        <h2 style={styles.subHeader}>Book Now and Arrive in Style</h2>
        <p style={styles.paragraph}>
          Choose eTravo for your next luxury ride and experience the thrill and elegance of Audi. 
          Reserve now via call or WhatsApp — because your journey should be as premium as your destination.
        </p>
      </div>
    </>
  );
};

export default AudiLuxuryCars;
